import React from "react";
import { connect } from "react-redux";
import routes from "../../../assets/apiRoutes.json"
import Popup from 'devextreme-react/popup';
import ScrollView from "devextreme-react/scroll-view";
import { GridLayout } from "../../../common/GridLayout";
import { Localization } from "../../../common/Localization";
import DataGrid, {
    Column,
    Editing,
    Paging,
    RequiredRule,
    StringLengthRule,
    Toolbar,
    Item,
    FilterRow,
    FilterPanel,
    FilterBuilderPopup,
    ColumnChooser,
    ColumnChooserSearch,
    ColumnFixing,
    Sorting,
    Export,
    Pager,
    HeaderFilter,
    Lookup,
    StateStoring
} from 'devextreme-react/data-grid';
import { Button } from 'devextreme-react/button';
import { createStore } from 'devextreme-aspnet-data-nojquery';
import AddTMLocationCodes from './AddLocationCode';
import GridLayoutManager from "../../../gridLayoutCustomization/GridLayoutManager";

const filterBuilderPopupPosition = {
    of: window,
    at: 'top',
    my: 'top',
    offset: { y: 10 },
};

const allowedPageSizes = [10, 20, 100, 500, 1000, "all"];
const dataGrid = React.createRef();
let accessToken = '';

const gridKey = "b515987a-49bd-4432-bbde-98c3c6a33109";
class LocationCodesGrid extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            selectedItemKeys: [],
            isAddLocationVisible: false,
            currentLayout: "Default",
        };

        accessToken = props.oidc.user.access_token;
        this.onContentReady = this.onContentReady.bind(this);
        this.AddLocationClick = this.AddLocationClick.bind(this);
        this.handleClosePopUpCallback = this.handleClosePopUpCallback.bind(this);
        this.BlockDataSource = this.BlockDataSource.bind(this);

        this.statusArr = [
            { id: 1, name: 'Active', value: 'A' },
            { id: 2, name: 'Inactive', value: 'I' },
            { id: 3, name: 'Unavailable', value: 'U' }];
        this.PositionEditorOptions = {
            format: {
                type: "#",
                min: 0
            },
        };

        this.OrchardDataSource = createStore({
            key: "id",
            loadUrl: `${window._env_.REACT_APP_APIS}/${routes.Orchard.GetOrchardCodes}`,
            onBeforeSend: function (method, ajaxOptions) {
                ajaxOptions.headers = {
                    Authorization: `Bearer ${accessToken}`
                };
            }
        });
        this.dataSource = createStore({
            key: 'rowid',
            loadUrl: `${window._env_.REACT_APP_APIS}/${routes.TMLocation.GetAllLocationCodes}`,
            updateUrl: `${window._env_.REACT_APP_APIS}/${routes.TMLocation.UpdateTMLocationCode}`,
            deleteUrl: `${window._env_.REACT_APP_APIS}/${routes.TMLocation.DeleteTMLocationCode}`,
            onBeforeSend: function (method, ajaxOptions) {
                ajaxOptions.headers = {
                    Authorization: `Bearer ${accessToken}`
                };
            }
        });
    }
    setCurrentLayout =(value)=>{
        this.setState({
          currentLayout:value
        })
      }
      loadState = () => {return GridLayout.sendStorageRequest(gridKey, "GET", accessToken,null, this.state.currentLayout);}
      saveState=(state)=> { GridLayout.sendStorageRequest(gridKey, "POST", accessToken, state, this.state.currentLayout);}    
    BlockDataSource(options) {
        return {
            store: createStore({
                key: "id",
                loadUrl: `${window._env_.REACT_APP_APIS}/${routes.Blocks.GetBlockCodes}`,
                onBeforeSend: function (method, ajaxOptions) {
                    ajaxOptions.headers = {
                        Authorization: `Bearer ${accessToken}`
                    };
                }
            }),
            filter: options.data ? ['R_WareHouse', '=', options.data.orchard] : null
        };
    }

    AddLocationClick() {
        this.setState({
            isAddLocationVisible: true,
        });
    }
    setOrchardStateValue(rowData, value) {
        rowData.block = null;
        this.defaultSetCellValue(rowData, value);
    }
    handleClosePopUpCallback() {
        this.setState({
            isAddLocationVisible: false,
        });
        dataGrid.current.instance().refresh();
    };

    render() {
        return (
            <div className="h-100" >
                <DataGrid

onExporting={(e) => {
          if (window.handleDevExtremeDataGridExport) {
            window.handleDevExtremeDataGridExport(e);
          }
        }} id="gridContainer"
                    onContentReady={this.onContentReady}
                    ref={dataGrid}
                    showBorders={true}
                    className="FullPageGridHeight"
                    //selectedRowKeys={this.state.selectedItemKeys}
                    //onSelectionChanged={this.selectionChanged}
                    rowAlternationEnabled={true}
                    allowColumnReordering={true}
                    allowColumnResizing={true}
                    columnAutoWidth={true}
                >
                    {/** <Selection mode="multiple" />*/}
                    <Paging
                        enabled={true}
                    />
                    <Pager
                        visible={true}
                        showPageSizeSelector={true}
                        allowedPageSizes={allowedPageSizes}
                        showNavigationButtons={true}
                        showInfo={true}
                    />
                    <FilterRow visible={true} />
                    <FilterPanel visible={true} />
                    <FilterBuilderPopup position={filterBuilderPopupPosition} />
                    <ColumnChooser
                        enabled={true}
                        title="Choose Column"
                        width={290}
                        height={290}
                        sortOrder="asc"
                    >
                        <ColumnChooserSearch
                            enabled={true}
                            editorOptions={{ placeholder: 'Search column' }} />
                    </ColumnChooser>
                    <HeaderFilter visible={true} />
                    <ColumnFixing enabled={true} />,
                    <Export enabled={true} allowExportSelectedData={true} text="Export" />
                    <Sorting mode="multiple" />
                    <Editing
                        mode="cell"
                        newRowPosition="first"
                        refreshMode="repaint"
                        allowUpdating={true}
                        allowAdding={true}
                        allowDeleting={true} />
                    <StateStoring
                        enabled={true}
                        type="custom"
                        customLoad={this.loadState}
                        storageKey={gridKey}
                        customSave={this.saveState}
                    />
                    <Column dataField="orchard" caption="Orchard Code" setCellValue={this.setOrchardStateValue}>
                        <Lookup
                            displayExpr="name"
                            valueExpr="id"
                            dataSource={this.OrchardDataSource} />
                        <RequiredRule message="Orchard Code is required." />
                    </Column>
                    <Column dataField="block" caption="Block Code">
                        <Lookup
                            dataSource={this.BlockDataSource}
                            displayExpr="name"
                            valueExpr="id" />
                    </Column>
                    <Column dataField="code" caption="Location Code">
                        <RequiredRule message="Code(Location) is required." />
                        <StringLengthRule message="Code must have at least 3 chracters and maximum 20" min={3} max={20} />
                    </Column>
                    <Column dataField="description" caption="Location Description"></Column>
                    <Column dataField="status" caption="Location Status">
                        <Lookup
                            dataSource={this.statusArr}
                            displayExpr="name"
                            valueExpr="value"
                            defaultValue={"A"} />
                    </Column>
                    <Column dataField="positionx"
                        dataType="number"
                        editorOptions={this.PositionEditorOptions}
                        caption="Orchard Row"></Column>
                    <Column dataField="positiony"
                        dataType="number"
                        editorOptions={this.PositionEditorOptions}
                        caption="Orchard Col"></Column>
                    <Column dataField="comment" caption="Location Comment"></Column>
                    <Column dataField="assets" caption="Location Assets"></Column>
                    <Toolbar>
                        <Item location="before">
                            <Button onClick={this.AddLocationClick} text="Add Location" type="default" stylingMode="contained" className="margin-right" />
                        </Item>
                        <Item location="after">
                        <GridLayoutManager gridKey={gridKey} dataGrid={dataGrid} setCurrentLayout={this.setCurrentLayout} />
                 </Item>
                        <Item name="exportButton" />
                        <Item name="columnChooserButton" />
                    </Toolbar>
                </DataGrid>
                {this.state.isAddLocationVisible &&
                    <Popup
                        visible={this.state.isAddLocationVisible}
                        onHiding={this.handleClosePopUpCallback}
                        dragEnabled={false}
                        hideOnOutsideClick={true}
                        showCloseButton={true}
                        showTitle={true}
                        title="Add Location"
                        container="#root"
                        closeOnOutsideClick={true}
                        height={600}
                        width={600}
                    >
                        <ScrollView width="100%" height="100%">
                            <AddTMLocationCodes parentCallback={this.handleClosePopUpCallback}
                            ></AddTMLocationCodes>
                        </ScrollView>
                    </Popup>}
            </div>
        );
    }

    onContentReady(e) {
        if (!e.component._hasLoaded) {
            e.component._hasLoaded = true;
            e.component.option("dataSource", this.dataSource);
        }
    }

    selectionChanged(data) {
        this.setState({
            selectedItemKeys: data.selectedRowKeys,
        });
    }
}

function mapStateToProps(state) {
    return {
        ReceiptReducer: state.ReceiptReducer,
        oidc: state.oidc,
    };
}

export default connect(mapStateToProps)(LocationCodesGrid);
